module.exports = __webpack_public_path__ + "img/cloudnine.cde6ddd7.jpeg";